import appnexus from './appnexus';
import noAppnexus from './appnexus/no';
import seAppnexus from './appnexus/se';

import publisherdesk from './publisherdesk';
import gbPublisherdesk from './publisherdesk/gb';
import frPublisherdesk from './publisherdesk/fr';

const commonConfig = {
  service: 'appnexus',
  appnexus,
  headerBiddingEnabled: false,
  publisherdesk,
};

export const dk = { ...commonConfig };
export const es = { ...commonConfig };
export const fi = { ...commonConfig };
export const fr = {
  ...commonConfig,
  headerBiddingEnabled: true,
  service: 'publisherdesk',
  publisherdesk: frPublisherdesk,
};
export const gb = {
  ...commonConfig,
  headerBiddingEnabled: true,
  service: 'publisherdesk',
  publisherdesk: gbPublisherdesk,
};
export const ie = { ...commonConfig };
export const it = { ...commonConfig };
export const no = { ...commonConfig, appnexus: noAppnexus };
export const nz = { ...commonConfig };
export const pl = { ...commonConfig };
export const se = {
  ...commonConfig,
  appnexus: seAppnexus,
};

export default {
  dk,
  es,
  fi,
  fr,
  gb,
  ie,
  it,
  no,
  nz,
  pl,
  se,
};
